import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter, HideScrollbar } from '../../../global/commonStyle';

interface Props {
  maxHeight?: number;
}

const Form = styled.div<Props>`
  padding: var(--space-16) var(--space-16) var(--space-20);
  display: flex;
  flex-direction: column;
  border-radius: var(--border-radius-0);
  .tiptap {
    min-height: ${(props) => props.maxHeight}px;
    max-height: ${(props) => props.maxHeight}px;
    height: 100%;
    ${HideScrollbar}
  }
`;

const ModalBox = styled.div`
  padding: var(--space-16);
  ${FlexCenter}
  flex-direction: column;
  position: relative;
  max-width: 500px;
  height: 436px;
  width: calc(100% - 32px);
  .closeIcon {
    position: absolute;
    top: 10px;
    right: 10px;
  }
`;
const TitleDiv = styled.div`
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-8);
  max-width: 380px;
  width: 100%;
`;

const TitleSuccess = styled.div`
  ${Typography.heading_md}
  color: var(--text-primary);
`;

const DescriptionSuccess = styled.div`
  ${Typography.body_md}
  color: var(--text-secondary);
`;

const BottomBox = styled.div`
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-20);
`;

// File Upload Design CSS
const FileBox = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: var(--space-10);
  max-height: 159px;
  ${HideScrollbar}
`;

// Bottom Button Design CSS
const ButtonComponent = styled.div`
  width: 468px;
  display: flex;
  gap: var(--space-12);
  padding: var(--space-0) var(--space-16) var(--space-16);
  position: absolute;
  bottom: 0;
  ${mobile_xl(css`
    width: calc(100vw - 64px);
  `)}
`;
const ButtonLeft = styled.div`
  width: 100%;
  ${AlignCenter}
  gap: var(--space-12);
`;

const ButtonRight = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: var(--space-12);
`;
const SvgDiv = styled.div`
  ${FlexCenter}
  width: 32px;
  height: 32px;
  cursor: pointer;
  svg {
    path {
      fill: var(--text-secondary);
    }
  }
  &:hover {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-full);
    svg path {
      fill: var(--text-primary);
    }
  }
`;
const UploadDiv = styled.div`
  color: var(--text-primary);
`;

const InputDiv = styled.div`
  display: flex;
  gap: var(--space-24);
  flex-direction: column;
`;

export {
  Form,
  ModalBox,
  TitleSuccess,
  TitleDiv,
  DescriptionSuccess,
  BottomBox,
  FileBox,
  ButtonComponent,
  ButtonLeft,
  ButtonRight,
  SvgDiv,
  UploadDiv,
  InputDiv
};
